module.exports = require('@feathersjs/primus-client');
